/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_6Aliases {
  DATE_PICKER_SCHEDULE_RANGE = 'date-picker-schedule-range',
  LAYOUT_SCHEDULE_PERIOD = 'layout-schedule-period',
  LINK_CALL_WAITING_LIST = 'link-call-waiting-list',
  PANEL_NOTIFICATION_SCHEDULE_PERIOD = 'panel-notification-schedule-period',
  PANEL_SCHEDULE_PERIOD = 'panel-schedule-period',
  TOAST_NOTIFICATION_WAITING_LIST = 'toast-notification-waiting-list',
}
export { PseudonymAppointmentsStep_6Aliases };
